var eventToolbox = require('src/interlock/no-ui/utils/event-toolbox/event-toolbox');
var debounce = require('throttle-debounce/debounce');
var REFRESH_ZONES = require('src/interlock/product/ads/refresh-zones');

function fireWidgetViewEvent(data, addRefresh) {
    if (data && data.relatedTarget) {

        var creativeId = data.relatedTarget.replace('#', '');
        eventToolbox.fireAction({
            'event_type': 'widget_view',
            'ads': {
                disable_refresh: !addRefresh
            },
            'event_data': {
                'action_name': 'widget_view',
                'action_cause': 'scroll',
                'creative_id': creativeId
            }
        });
    }
}

function fireTrackingFromDataStorage(data) {
    if (data && data.relatedTarget) {
        var creativeId = data.relatedTarget.replace('#', '');
        var trackingData = window.EDMDataStorage[creativeId] || {};

        if (Object.keys(trackingData).length > 0) {
            trackingData.ads = {
                disable_refresh: true
            };
            eventToolbox.fireAction(trackingData);
        }
    }
}

var addRefresh;
var debouncedHandler = debounce(100, function (ev, data) {
    fireWidgetViewEvent(data, addRefresh);
    fireTrackingFromDataStorage(data);
    addRefresh = true;
});

// We are not using this, but I am going to leave it here for now.
// debounce seemed to have caused perceived loading issues
// with deferred modules as a user scrolls. (WEB-791)
// This was introduced by WEB-444
// var engagementDebounce = debounce(100, function(){
//    eventToolbox.fireCustomEvent(REFRESH_ZONES.ENGAGEMENT, {});
//});

$(window).on('activate.bs.scrollspy', function (ev, data) {
    debouncedHandler(ev, data);
});


// We are removing debounce  due to perceived loading issues
// with deferred modules as a user scrolls. (WEB-791)
// This was introduced by WEB-444
function setEngagementScroll(){
    $(window.document).on('scroll', function() {
        eventToolbox.fireCustomEvent(REFRESH_ZONES.ENGAGEMENT, {});
        //this event 'engagement' is not being used as an ad refresh zone in this scenario.
    });
    //$(window.document).on('scroll', engagementDebounce);
}

$(window.document).ready(function() {
    window.setTimeout(function() {
        setEngagementScroll();
    }, 1000);
});



//////////////////
// WEBPACK FOOTER
// ./src/interlock/no-ui/engagement-handler/scroll-engagement-handler/scroll-engagement-handler.js
// module id = 437
// module chunks = 36